import BlankFavoriteShop from '@components/blank/BlankFavoriteShop';
import BlankShop from '@components/blank/BlankShop';
import Column from '@components/Column';
import InfinityScrollTrigger from '@components/InfinityScrollTrigger';
import styled from '@emotion/styled';
import { ShopInMapRow } from '@models/shop';
import { useAtomValue } from 'jotai';

import ShopItem from './ShopItem';
import ShopItemSkeletons from './ShopItemSkeletons';
import { isMyShopAtom } from '../../atoms/shopsInMapAtoms';

interface Props {
    isOrder: boolean;
    shops?: ShopInMapRow[];
    fit?: boolean;
    isLoading?: boolean;
    isBlank?: boolean;
    originalItemId?: string;
    fetchNext?: ()=> void;
}

function ShopList({
    isOrder, shops, fit, isLoading, isBlank, originalItemId, fetchNext,
}:Props) {
    const isMyShop = useAtomValue(isMyShopAtom);
    if (isBlank && !isLoading) {
        if (isMyShop) {
            return <BlankFavoriteShop/>;
        }
        return <BlankShop fit={fit}/>;
    }

    return (
        <Container as='section'
            fullWidth>
            <Column as='article'
                fullWidth >
                {shops?.map((shop) => (
                    <ShopItem key={shop.id}
                        originalItemId={originalItemId}
                        isOrder={isOrder}
                        shop={shop}/>
                ))}
                <InfinityScrollTrigger trigger={fetchNext} />
                {isLoading && (
                    <ShopItemSkeletons count={shops?.length ? 1 : 3} />
                )}
            </Column>
        </Container>
    );
}

const Container = styled(Column)`
    padding: 0 var(--spacing-4);
`;

export default ShopList;
